import { useCallback } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

import logout from '../../../helpers/logout';
import { useAuth0Context } from 'lane-shared/contexts/Auth0Context';
import { useGetAuthToken } from 'hooks/useGetAuthToken';
import { useAuth0WebRedirectURL } from 'hooks/useAuth0WebRedirectURL';

export function useAuthClearSession() {
  const auth0WebRedirectURL = useAuth0WebRedirectURL();
  const { logout: auth0Logout, isAuthenticated } = useAuth0();
  const { setIsAuth0LogoutInProgress } = useAuth0Context();
  const getAuthToken = useGetAuthToken();

  return useCallback(async () => {
    if (isAuthenticated) {
      setIsAuth0LogoutInProgress(true);

      await logout(getAuthToken, {
        emitLogout: true,
        emitAuthTokenInvalid: true,
      });
      await auth0Logout({
        openUrl: false,
      });
      auth0Logout({
        logoutParams: { returnTo: auth0WebRedirectURL },
      });
    }
  }, [isAuthenticated, auth0Logout, auth0WebRedirectURL]);
}
